import { GET_COMPONENTS_SERVER } from '@api/queries/components';
import {
    ComponentOrderField,
    type GetComponentsServerQuery,
    OrderDirection,
} from '@gql/graphql';
import {
    Datasource,
    type GraphQLDataSourceOptions,
    GraphQLDataSourceStrategy,
} from '@utils/ag-datasource/ag-datasource';
import { flatMapEdges } from '@utils/flatMapEdges';
import { getComponentSearchWhere } from './get-component-search-where';

/**
 * Create a datasource for the grid.
 * It acts as a layer between the grid and the backend, managing the communication between the two,
 * for example, applying sorting and filtering variables to the query.
 */
export function getComponentsTableDataSource(searchTerm = ''): Datasource {
    const where = getComponentSearchWhere(searchTerm);
    const options: GraphQLDataSourceOptions = {
        query: GET_COMPONENTS_SERVER,
        variables: {
            orderBy: {
                field: ComponentOrderField.Name,
                direction: OrderDirection.Asc,
            },
            ...(where ? { where } : {}),
        },
        debug: false,
        hardLimit: 100,
    };

    const graphQLStrategy =
        new GraphQLDataSourceStrategy<GetComponentsServerQuery>(
            options,
            ({ data: { components } }) => ({
                rows: flatMapEdges(components),
                totalCount: components.totalCount,
            }),
        );

    return new Datasource(graphQLStrategy);
}
